import type { DocNode as ADF } from '@atlaskit/adf-schema';

export const createSampleAdf = (content: string): ADF => ({
	version: 1,
	type: 'doc',
	content: [
		{
			type: 'paragraph',
			content: content ? [{ type: 'text', text: `${content}` }] : [],
		},
	],
});

export const createSampleMediaNode = (id: string) => ({
	type: 'mediaSingle',
	attrs: {
		layout: 'center',
	},
	content: {
		type: 'media',
		attrs: {
			id,
			type: 'file',
			collection: 'jira-16161-comment-12278',
			width: 873,
			height: 233,
		},
	},
});

export const createSampleMentionNode = (id: string) => ({
	type: 'mention',
	attrs: { id, text: 'No name' },
});

export const createSampleInlineCard = (url: string) => ({
	type: 'inlineCard',
	attrs: {
		url,
	},
});

export const sampleADFWithMediaNodeWithoutCollection = {
	content: [
		{
			type: 'mediaGroup',
			content: [
				{
					type: 'media',
					attrs: {
						height: 564,
						id: '657b1eb4-f37e-4f12-87c8-cb744eefa182',
						type: 'file',
						collection: '',
						occurrenceKey: 'e60db371-2c26-4e2f-8294-77497bde6fe3',
						width: 860,
					},
				},
			],
		},
	],
	type: 'doc',
	version: 1,
};

export const sampleAdfWithTextAndMedia = {
	content: [
		...sampleADFWithMediaNodeWithoutCollection.content,
		{
			type: 'paragraph',
			content: [{ type: 'text', text: 'hello' }],
		},
	],
	type: 'doc',
	version: 1,
};

export const sampleStringifiedADFWithMediaNodeWithCollection =
	'{"version":1,"type":"doc","content":[{"type":"mediaGroup","content":[{"type":"media","attrs":{"id":"657b1eb4-f37e-4f12-87c8-cb744eefa182","type":"file","collection":"jira-10180-comment-10242","occurrenceKey":"e60db371-2c26-4e2f-8294-77497bde6fe3","width":860,"height":564}}]}]}';
